<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('child_reports.followup_report') }}</h4>
          </template>
          <template v-slot:body>
            <b-row>
                <b-col xl="12" lg="12" sm="12">
                    <ValidationProvider>
                        <b-form-group
                            class="text-center"
                            label-for="report_type"
                            slot-scope="{ valid, errors }"
                            >
                            <b-form-radio-group
                                v-model="search.report_type"
                                :options="reportTypeList"
                                value-field="item"
                                text-field="name"
                                :state="errors[0] ? false : (valid ? true : null)"
                                ></b-form-radio-group>
                            <div class="invalid-feedback d-block">
                            {{ errors[0] }}
                            </div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <component :is='comp' />
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>

import reportAll from './reportAll'
import reportSingle from './reportSingle'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'

export default {
  mixins: [ModalBaseMasterList],
   components: {
    reportAll, reportSingle
  },
  data () {
    return {
      comp: 'reportAll',
      saveBtnName: this.$t('globalTrans.save'),
      search: {
        report_type: 1
      },
      optionsTypeList: [
          { item: 1, text_en: 'All', text_bn: 'সব' },
          { item: 2, text_en: 'Individual', text_bn: 'পৃথক' }
      ]
    }
  },
  computed: {
    reportTypeList: function () {
        return this.optionsTypeList.map(item => {
            return Object.assign({}, item, { name: this.$i18n.locale === 'en' ? item.text_en : item.text_bn })
        })
    },
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
    'search.report_type': function (newVal, oldVal) {
        if (newVal !== oldVal) {
            if (parseInt(newVal) === 1) {
                this.comp = 'reportAll'
            } else {
                this.comp = 'reportSingle'
            }
        }
    }
  },
  created () {
      this.search.org_id = this.$store.state.dataFilters.orgId
      this.search.office_type_id = this.$store.state.dataFilters.officeTypeId
      this.search.office_id = this.$store.state.dataFilters.officeId
  },
  mounted () {
  },
  methods: {
  }
}
</script>
